import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Carousel } from 'react-bootstrap';
import ConsultantForm from './ConsultantForm';
import EmployerSignupPanel from './EmployerSignupPanel';
import { analyticsTrack } from '../../analyticsUtils';
import './Registration.scss';

const consultantTestimonials = () => {
  const donna = {
    name: 'Donna S.',
    title: 'Global Clinical Project Manager, QA/QC',
    body: 'One of the things that I find remarkable about '
          + 'Clora is the wide range of projects that are available. '
          + 'As a QA auditor and Project Manager, I regularly come '
          + 'across projects that interest me on the platform [...] '
          + 'the clients have been really wonderful to work with.',
  };

  const sergey = {
    name: 'Sergey I.',
    title: 'Data Manager',
    body: 'Working with Clora is such a pleasure! '
          + 'From the on-boarding process to ongoing interactions '
          + 'everyone has been professional and helpful. '
          + 'This model and platform is the future of contracting '
          + 'in our industry.',

  };

  const angel = {
    name: 'Angel K.',
    title: 'Clinical Project Manager',
    body: 'Clora helped me to match my skills and '
          + 'interests to a company\'s needs [...]. In '
          + 'over 6 years of consulting, Clora has been '
          + 'the smoothest process to match my expertise '
          + 'to a contract opportunity. It has been a pleasure '
          + 'working with the entire Clora team.',
  };

  const niti = {
    name: 'Niti G.',
    title: 'Clinical Development Consultant',
    body: 'I deeply appreciate my relationship with Clora '
          + 'and their professionalism. They value and support '
          + 'me through every step of the process and demonstrate '
          + 'a clear commitment to matching the right projects with '
          + 'the right consultants.',

  };

  const dorothy = {
    name: 'Dorothy F.',
    title: 'Medical Writer, Preclinical & Pharmacology Consultant',
    body: 'I began my consulting business [...] after years '
           + 'of fulltime employment [...]. I was very pleased with '
           + 'how quickly I matched with contract opportunities '
           + 'that were ideally suited for my expertise. '
           + 'The Clora team has done a wonderful job of seamlessly '
           + 'integrating my consulting role with their customers.',
  };

  return ([donna, sergey, angel, niti, dorothy]);
};

const renderConsultantTestimonials = () => {
  const testimonials = consultantTestimonials();

  return (
    <div className="consultant-testimonial-carousel">
      {/* Change interval as necessary!! */}
      <Carousel
        controls={false}
        interval={12500}
        touch
      >
        { testimonials.map((testimony) => (
          <Carousel.Item>
            <div className="consultant-testimonial-blurb">
              <h1 className="quote-symbol"> &#8220; </h1>
              <p className="testimonial-text">
                {testimony.body}
              </p>
            </div>
            <div className="triangle" />
            <div className="consultant-testimonial-byline">
              <div className="consultant-name body-text-2">{testimony.name}</div>
              <div className="consultant-title body-text-2">{testimony.title}</div>
            </div>
          </Carousel.Item>
        )) }
      </Carousel>
    </div>
  );
};

const renderCopy = () => (
  <Fragment>
    <h1 className="hero-header registration-welcome-title">
      Stop searching.
    </h1>
    <h1 className="hero-header registration-welcome-title">
      Start working.
    </h1>
  </Fragment>
);

const consultantTestimonialsPanel = () => (
  <div className="right-panel d-none d-md-block">
    <div className="hidden-at-1k">
      {renderConsultantTestimonials()}
    </div>
  </div>
);

const referralPanel = (referrer) => (
  <div className="left-panel">
    <h1 className="hero-header registration-welcome-title">
      {referrer}
      {' '}
      wants you to meet Clora.
    </h1>
    <div className="body-text-1 registration-welcome-body">
      Your friend,
      {' '}
      {referrer}
      , thinks you are a great fit for Clora. Join the
      platform and find relevant projects based on your career interest and availability.
    </div>
    {renderConsultantTestimonials()}
  </div>
);

class Registration extends Component {
  constructor(props) {
    super(props);

    this.state = {
      consultantView: props.consultantView,
      password: null,
    };
    this.toggleConsultantView = this.toggleConsultantView.bind(this);
    this.toggleEmployerView = this.toggleEmployerView.bind(this);
  }

  toggleConsultantView() {
    this.setState({ consultantView: true });
    analyticsTrack('Consultant Registration Form');
    window.history.pushState(null, 'Clora Consultant Registration', '/registration/new');
  }

  toggleEmployerView() {
    this.setState({ consultantView: false });
    analyticsTrack('Employer Registration Form');
    window.history.pushState(null, 'Clora Employer Registration', '/registration/new?view=employer');
  }

  renderErrors() {
    const { errors } = this.props;
    if (errors) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            { Object.entries(errors).map((message) => (
              <li>{message[1]}</li>
            ))}
          </ul>
        </div>
      );
    }
    return null;
  }

  renderForm() {
    const { consultantView } = this.state;
    const {
      csrfToken,
      invitedEmail,
      company,
      referrer,
      referralToken,
      referrerCompany,
      signInUrl,
      googleOmniauthUrl,
      msOmniauthUrl,
    } = this.props;

    if (navigator.userAgent.indexOf('Chrome') !== -1) {
      document.body.className += ' chromium';
    }

    if (consultantView) {
      const withReferral = referrer && referralToken && !referrerCompany;

      const formWithErrors = (
        <div className="form">
          {this.renderErrors()}
          {renderCopy()}
          <ConsultantForm
            csrfToken={csrfToken}
            invitedEmail={invitedEmail}
            referralToken={referralToken}
            googleOmniauthUrl={googleOmniauthUrl}
            msOmniauthUrl={msOmniauthUrl}
          />
          <hr />
          <div className="body-text-2 medium-weight text-center mt-3">
            Already have a Clora account?&nbsp;
            <a href={signInUrl} className=" p-0">Log in</a>
          </div>
        </div>
      );

      const row = (
        <Row className="consultant-registration">
          <Col xs sm>
            {withReferral ? referralPanel(referrer) : formWithErrors}
            {!withReferral
              && (
              <div className="d-block d-md-none">
                {renderConsultantTestimonials()}
              </div>
              )}
          </Col>
          <Col xs={12} sm={6}>
            {withReferral ? formWithErrors : consultantTestimonialsPanel()}
          </Col>
        </Row>
      );

      return row;
    }

    return (
      <div>
        {this.renderErrors()}
        <EmployerSignupPanel
          csrfToken={csrfToken}
          invitedEmail={invitedEmail}
          company={company}
          referrer={referrer}
          referralToken={referralToken}
          referrerCompany={referrerCompany}
          signInUrl={signInUrl}
          googleOmniauthUrl={googleOmniauthUrl}
          msOmniauthUrl={msOmniauthUrl}
        />
        {' '}

      </div>
    );
  }

  render() {
    const { consultantView } = this.state;
    return (
      <div className="style-guide">
        <div className="registration-tabs">
          <Row className="toggleView">
            <Col xs={6} sm={3}>
              <div className={`text-center consultant-toggle selected-${consultantView}`} role="button" tabIndex="0" onClick={() => this.toggleConsultantView()}><h2>Consultant</h2></div>
            </Col>
            <Col xs={6} sm={3}>
              <div className={`text-center employer-toggle selected-${!consultantView}`} role="button" tabIndex="-1" onClick={() => this.toggleEmployerView()}><h2>Employer</h2></div>
            </Col>
          </Row>
        </div>
        <div className="registration">
          {this.renderForm()}
        </div>
      </div>
    );
  }
}

Registration.propTypes = {
  csrfToken: PropTypes.string.isRequired,
  invitedEmail: PropTypes.string,
  company: PropTypes.string,
  consultantView: PropTypes.bool,
  referralToken: PropTypes.string,
  referrer: PropTypes.string,
  referrerCompany: PropTypes.string,
  errors: PropTypes.shape([]),
  signInUrl: PropTypes.string.isRequired,
  googleOmniauthUrl: PropTypes.string,
  msOmniauthUrl: PropTypes.string,
};

Registration.defaultProps = {
  invitedEmail: null,
  company: null,
  consultantView: true,
  referralToken: null,
  referrer: null,
  referrerCompany: null,
  errors: null,
  googleOmniauthUrl: null,
  msOmniauthUrl: null,
};

export default Registration;
